// extracted by mini-css-extract-plugin
export default {"FooterHeading":"FooterHeading-module--FooterHeading--9eeaa","FooterHeadingPurpleTheme":"FooterHeading-module--FooterHeadingPurpleTheme--6cb89"};